import React from 'react';
import { IonButton } from '@ionic/react';
import { TeamCertificationSummary } from '../../types/teamSummary';

const TEAM_PROGRESS_ICON_URL = 'https://storage.googleapis.com/rev-public/icons/Report_%20Team%20Progress.svg';

interface ReportWidgetProps {
  certifications: TeamCertificationSummary[];
}

export const ReportWidget: React.FC<ReportWidgetProps> = ({ certifications = [] }) => {
  return (
    <div className="bg-white flex w-full sm:min-w-60 flex-col px-5 py-4 rounded-[10px]">
      {/* Row 1: Icon and Title */}
      <div className="flex w-full items-center">
        <div className="flex items-center gap-3">
          <img
            src={TEAM_PROGRESS_ICON_URL}
            alt="Team Progress"
            className="w-8 h-8"
          />
          <div className="text-[#2D2D2D] text-base font-medium">
            Report: Team Progress
          </div>
        </div>
      </div>

      {/* Certifications - bottom aligned */}
      <div className="flex flex-col mt-auto">
        {certifications.length === 0 ? (
          <div className="pt-3">
            <p className="text-[#928881] text-base font-normal italic">No course progress</p>
          </div>
        ) : (
          certifications.map((cert, index) => (
            <div
              key={cert.certificationId}
              className={`flex w-full items-center justify-between ${index === 0 ? 'mt-3' : 'mt-2'}`}
            >
              <div className="text-[#928881] text-base font-normal">
                {cert.name}
              </div>
              <div className="text-[#928881] text-base font-normal">
                {cert.progress}%
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
